import React, { ReactNode } from 'react';
import classNames from 'classnames';
import './SectionFooter.pcss';
import { Panel } from '../SignUpPanel/Panel';
import { SignUpLogo } from '../SignUpLogo/SignUpLogo';
import { useResolutionInfo } from '@mm/hooks';
import { Link } from '@mm/components';
import { Routes } from '../../../../../routes/top-level-routes';

type Props = {
  className?: string;
  children?: string | ReactNode | Element[];
};

const Links = ({ className, children }: Props) => (
  <>
    {children}
    <Link
      className="sign-up-footer__link"
      rel="noopener noreferrer"
      href="https://customers.ai/our-team/"
      isBlank={true}
    >
      About Us
    </Link>
    <Link
      className="sign-up-footer__link"
      rel="noopener noreferrer"
      href={Routes.masterServiceAgreement.getLink()}
      isBlank={true}
    >
      Terms of use
    </Link>
    <Link
      className="sign-up-footer__link"
      rel="noopener noreferrer"
      href={Routes.privacyPolicy.getLink()}
      isBlank={true}
    >
      Privacy Policy
    </Link>
    <Link
      className="sign-up-footer__link"
      rel="noopener noreferrer"
      href="https://customers.ai/#contact"
      isBlank={true}
    >
      Contacts
    </Link>
    <Link
      className="sign-up-footer__link"
      rel="noopener noreferrer"
      href="https://customers.ai/help/"
      isBlank={true}
    >
      Support
    </Link>
  </>
);

export const SectionFooter = ({ className }: Props) => {
  const { isTablet } = useResolutionInfo();
  return (
    <div className={classNames(className, 'sign-up-footer')}>
      <div className="sign-up-footer__container">
        <SignUpLogo className="sign-up-footer__logo" />

        <Panel title="Home" className="sign-up-footer__links-panel">
          <Links />
        </Panel>

        <div className="sign-up-footer__links-and-copy-container">
          <div className="sign-up-footer__links">
            <Links>
              <Link
                className="sign-up-footer__link"
                href="https://customers.ai/"
                rel="noopener noreferrer"
                isBlank={true}
              >
                Home
              </Link>
            </Links>
          </div>

          <div className="sign-up-footer__copy">
            <span>© Customers.ai, Inc. All rights reserved</span>
            <span>
              Questions? Call us:
              <Link className="sign-up-footer__phone" href="tel:855.720.2694">
                855.720.2694
              </Link>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
